import * as React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

interface Props {
  title: string;
  isOpen: boolean;
  busy?: boolean;
  confirmLabel?: string;
  confirmColor?: string;
  onCancel: () => void;
  onConfirm: () => void;
  children: React.ReactNode;
}

export const ConfirmModal: React.FC<Props> = ({
  title,
  isOpen,
  busy,
  confirmLabel = "Delete",
  confirmColor = "danger",
  onCancel,
  onConfirm,
  children,
}) => (
  <Modal isOpen={isOpen} toggle={onCancel}>
    <ModalHeader toggle={onCancel}>{title}</ModalHeader>
    <ModalBody>{children}</ModalBody>
    <ModalFooter>
      <Button color="secondary" onClick={onCancel} disabled={busy}>
        Close
      </Button>
      <Button color={confirmColor} onClick={onConfirm} disabled={busy}>
        {busy ? "Working…" : confirmLabel}
      </Button>
    </ModalFooter>
  </Modal>
);
